import React from 'react'
// @ts-ignore
import MixpanelContext from 'react-mixpanel'

export default function useMixpanel(): any {
  return React.useContext(MixpanelContext)
}
